export const PARTNER = {
  MMT: "mmt",
  GI: "gi",
  TRIPMONEY: "tripmoney",
  UNKNOWN: "unknown",
  MYPARTNER: "mypartner",
  MYBIZ: "mybiz",
} as const;

type PartnerKeys = keyof typeof PARTNER;
export type PartnerType = typeof PARTNER[PartnerKeys];
